import React, { Component } from 'react';
import StepperEvent from '../../../../../Components/StepperEvent';
import Table from '../../../../../Components/Table';
import { Card, CardBody, Row } from 'reactstrap';
import TablesEvent from './tablesEvent';
import { withRouter } from 'react-router-dom';

class Events extends Component {
  state = {
    HBL_HAWB: '',
    DocTransporte: '',
    doImportImpo: '',
    id: this.props.match.params.id,
    allSteps: [],
    allTables: [],
    data: [],
    columns: [
      { label: 'Descripción del Evento', key: 'EventDescription', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Fecha del Evento', key: 'EventDate', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Categoría de Responsable', key: 'CategoryResponsable', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Origen', key: 'Origin', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Fecha de Creación', key: 'CreateDate', idTh: 'firstTh', idTd: 'firstTd' },
    ],
    steps: [
      {
        label: 'Instrucción Cliente AA',
        value: '',
        id: 3,
        completed: false,
        order: 1,
        middleStep: ''
      },
      {
        label: 'ATA (Manifiesto)',
        value: '',
        id: 5,
        completed: false,
        order: 2,
        idStep: '',
        middleStep: ''
      },
      {
        label: 'Aceptación Solicitud DTA',
        value: '',
        id: 19,
        completed: false,
        order: 3,
        middle: false,
        idStep: '',
        middleStep: ''
      },
      {
        label: 'Autorización Inspección',
        value: '',
        id: 20,
        completed: false,
        order: 4,
        idStep: 'step4',
        middleStep: ''
      },
      {
        label: 'Salida DTA',
        value: '',
        id: 21,
        completed: false,
        order: 5,
        idStep: 'step5',
        middleStep: ''
      },
      {
        label: 'Finalización DTA',
        value: '',
        id: 22,
        completed: false,
        order: 6,
        idStep: 'step6',
        middleStep: ''
      },
      {
        label: 'Radicación de Factura',
        value: '',
        id: 16,
        completed: false,
        order: 7,
        idStep: 'step7',
        middleStep: ''
      }
    ]
  }

  componentDidMount = () => {
    this.setState({
      steps: this.props.steps,
      allSteps: this.props.allSteps,
      DocTransporte: this.props.DocTransporte,
      doImportImpo: this.props.doImportImpo,
      Estatus: this.props.Estatus,
      cliente: this.props.cliente,
      NIT: this.props.NIT,
      Grupo: this.props.Grupo
    }, () => {
      this.createTables();
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      steps: nextProps.steps,
      allSteps: nextProps.allSteps,
      DocTransporte: nextProps.DocTransporte,
      doImportImpo: nextProps.doImportImpo,
      Estatus: nextProps.Estatus,
      cliente: nextProps.cliente,
      NIT: nextProps.NIT,
      Grupo: nextProps.Grupo
    }, () => { this.createTables(); });
  }

  createTables = () => {
    var allTables = [];
    this.state.allSteps.map((e) => {
      var findTable = false;
      allTables.map((f) => {
        if (f.eventType === e.EventType) {
          f.data.push(e);
          findTable = true;
        }
        return f;
      });
      if (!findTable) {
        var obj = {
          eventType: e.EventType,
          data: [e]
        };
        allTables.push(obj);
      }
      return e;
    });
    this.setState({ allTables: allTables });
  }

  render() {
    let { cliente, NIT, Grupo } = this.state;

    return (
      <>
        <Card className="myCard">
          <CardBody>
            <Row>
              <div className='col-xs-2 col-md-1 col-lg-1 d-flex justify-content-center d-flex align-items-center'>
                <i style={{ color: '#a7a8a9' }} className="fa-3x fas fa-arrow-alt-circle-right"></i>
              </div>
              <div className='col-xs-10 col-md-6 col-lg-6'>
                <p className='sizeTextComents' >{cliente} ({NIT}) / {Grupo}</p>
                <p className='sizeTextComents' style={{ color: '#0099ff' }}>{this.state.doImportImpo}</p>
                <p className='sizeTextComents' > {this.state.DocTransporte}</p>
                <p className='sizeTextComents' > {this.state.HBL_HAWB}</p>
              </div>
              <div className='col-12 mt-1'>
                {this.state.Estatus}
              </div>
            </Row >
            <div className="col-12">
              <StepperEvent steps={this.state.steps} />
            </div>
          </CardBody>
        </Card>
        <Card className="myCard">
          <CardBody>
            {this.state.allTables.length > 0 ? <TablesEvent columns={this.state.columns} allTables={this.state.allTables} /> :
              <Table
                columns={this.state.columns}
                data={this.state.data}
                options={{
                  large: false,
                  downloads: {
                    pdf: false,
                    xlsx: false
                  }
                }} />}
          </CardBody>
        </Card>
      </>
    );
  }
}

export default withRouter(Events);
